import { FiberPin, Key } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  MenuItem,
  TextField,
} from "@mui/material";
import { GetAlertData } from "contexts/AlertContext";
import { GetData } from "contexts/DataContext";
import React from "react";

export function PinField(props) {
  const { dataObj, forceSetDataObj } = GetData();
  const { setAlert } = GetAlertData();
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState("");
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    props?.setAnchorEl(null);
  };
  return (
    <React.Fragment>
      <MenuItem disableRipple onClick={handleClickOpen}>
        Изменить пин-код
        <FiberPin />
      </MenuItem>
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle>Пин-код</DialogTitle>
        <DialogContent>
          <TextField
            InputProps={{
              style: {
                fontSize: dataObj?.deviceWidth?.isMobile ? "0.875rem" : "1rem",
              },
              startAdornment: (
                <InputAdornment position="start">
                  <Key />
                </InputAdornment>
              ),
            }}
            fullWidth
            inputProps={{
              maxLength: 6,
            }}
            label="Пин-код"
            mb={2}
            mt={2}
            name="pin"
            onChange={(e) => setValue(e.target.value?.replace(/\D/g, ""))}
            placeholder="Введите новый пин-код..."
            sx={{ margin: "0.875rem 0" }}
            type="text"
            value={value || ""}
            variant="standard"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отменить</Button>
          <Button
            onClick={() => {
              let newPin = value?.replace(/\D/g, "");
              forceSetDataObj(newPin, "pin");
              if (newPin) setAlert("Пин-код установлен");
              else setAlert("Пин-код удален", "warn");

              setValue("");
              handleClose();
            }}
          >
            Применить
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
